"use client";

import { ReactNode } from 'react';
import { useQLHV } from '../../../contexts/QLHVContext';

interface LayoutProps {
    onClose: () => void
    isSidebarOpen: boolean,
    children: ReactNode
}

export default function LayoutCompact({ children, isSidebarOpen }: LayoutProps) {
    const { isQLHVMode } = useQLHV();
    const sidebarWidth = 320 // w-80 = 320px
    // Nếu là chế độ QLHV, luôn tính leftPosition = sidebarWidth
    // Nếu không phải QLHV, tính theo isSidebarOpen
    const leftPosition = isQLHVMode ? sidebarWidth : (isSidebarOpen ? sidebarWidth + 16 : 16)

    return (
        <div
            className="fixed bottom-0 shadow-2xl z-35 transition-all duration-300"
            style={{
                left: `${leftPosition}px`,
                width: `calc(100vw - ${leftPosition}px - 16px)`,
                height: `350px`, // Compact height - much shorter than default
                ...(isQLHVMode ? {} : {
                    // For non-QLHV mode, position at bottom
                })
            }}
        >
            {children}
        </div>
    )
}
